import React from "react"
import { Body } from "../../atoms/Bodies"
import L10n from "lib/carrot-l10n"
import { TextLink } from "../../atoms/links/TextLink"
import Settings from "../../../../utils/CarrotConfig"
const l = new L10n({ locale: "en-US" }).getBoundLocalize()

// TODO: Explore i18n solution that supports templating of elements. The below technique is NOT how we should do this
export default function WeWillTakeItFromHere(props) {
  const supportCenterUrl = Settings.ZENDESK_GUIDE
  return (
    <Body {...props} color="black-80">
      We’ll take it from here and will let you know if we have any more questions. If we determine that you have a
      deductible, you’ll see the status on the <TextLink href="/transactions">{l`Transactions tab`}</TextLink>. You can
      read more about deductibles in our <TextLink href={supportCenterUrl}>{l`Support Center`}</TextLink>.
    </Body>
  )
}
